var map = {
	"./blog.yml": 116,
	"./cloud.yml": 117,
	"./color.yml": 118,
	"./country.yml": 119,
	"./dio.yml": 120,
	"./doc.yml": 121,
	"./emoji.yml": 122,
	"./git.yml": 123,
	"./icon.yml": 124,
	"./license.yml": 125,
	"./link.yml": 126,
	"./metrics.yml": 127,
	"./people.yml": 128,
	"./soft.yml": 129,
	"./src.yml": 130,
	"./status.yml": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;